import React from 'react'
import { ThemeProvider, createMuiTheme } from '@material-ui/core/styles'
import { useStaticQuery, graphql } from 'gatsby'

import 'material-kit-pro/assets/scss/material-kit-pro-react.scss?v=1.8.0'

import theme from '../theme'
import navigation from '../navigation'
import { PageContext } from '../page-context'
import Copyright from './Copyright'
import Footer from './Footer'
import Header from './Header'
import HeaderLinks from './HeaderLinks'
import HeroHeader from './HeroHeader'
import Main from './Main'
import { useSrcSets } from './useSrcSets'

const muiTheme = createMuiTheme(theme)

const Layout = ({ title, subtitle, image, header = {}, children }) => {
  const data = useStaticQuery(graphql`
    query LayoutQuery {
      images: allFile(filter: { sourceInstanceName: { eq: "contentImages" } }) {
        edges {
          node {
            base
            relativePath
            publicURL
            childImageSharp {
              fluid(maxWidth: 1600, quality: 90) {
                ...GatsbyImageSharpFluid
                srcSetWebp
              }
            }
          }
        }
      }
    }
  `)

  const images = data.images.edges.map(({ node }) => node)
  const heroImage = images.find(img => img.base === image)

  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        minHeight: '100vh',
        background: 'white',
      }}
    >
      <ThemeProvider theme={muiTheme}>
        <PageContext.Provider value={{ images }}>
          <>
            <Header
              links={
                <HeaderLinks
                  dropdownHoverColor="rose"
                  navigation={navigation}
                  {...header}
                />
              }
            />
            <div style={{ flex: '1 1 auto' }}>
              <HeroHeader
                title={title}
                subtitle={subtitle}
                image={useSrcSets(heroImage.childImageSharp)}
              />
              <Main>
                {children}
                <Footer />
              </Main>
            </div>
            <Copyright />
          </>
        </PageContext.Provider>
      </ThemeProvider>
    </div>
  )
}

export default Layout
